const styles = () => ({});

export const modalStyles = () => ({
  '.MuiDialog-container > .MuiPaper-root': {
    maxWidth: '680px !important',
  },
  '.dn-icon': {
    background: '#EDF8FF',
    width: '45px',
    height: '45px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '500px',
    marginBottom: '10px',
    svg: {
      fontSize: '20px',
      width: '20px',
      height: '20px',
      color: '#009EFF',
    },
  },
  '.dn-box-info': {
    maxWidth: '350px',
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '.MuiTypography-body1': {
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '16px',
      lineHeight: '21px',
      letterSpacing: '0.17',
      color: '#646464',
    },
    '.MuiTypography-body2': {
      marginTop: '10px',
      fontStyle: 'italic',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '14px',
      letterSpacing: '0.17',
      color: '#CDCDCD',
    },
  },
  '.dn-text-resend': {
    marginTop: '20px',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '21px',
    letterSpacing: 0.17,
    color: '#CDCDCD',
    '.dn-link-separator': {
      borderLeft: '1px solid #CDCDCD',
      display: 'inline',
      height: '40px',
      margin: '0px 20px',
    },
    a: {
      color: 'inherit',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
      '& + a': {
        marginLeft: '10px',
      },
    },
  },
  '.dn-button-primary.MuiButton-contained': {
    borderRadius: '500px !important',
    minWidth: '200px !important',
    background: '#2845D2 !important',
    color: '#ffffff !important',
    padding: '8px 25px !important',
    lineHeight: '1 !important',
    minHeight: '40px',
    '&:hover, &:focus, &:active': {
      backgroundColor: '#1431c2 !important',
      color: '#ffffff !important',
    },
  },
  '.dn-button-secondary.MuiButton-outlined': {
    borderRadius: '500px !important',
    minWidth: '150px !important',
    backgroundColor: '#fff !important',
    color: '#2845d2 !important',
    border: '1px solid #2845d2 !important',
    padding: '8px 25px !important',
    lineHeight: '1 !important',
    minHeight: '40px',
    '&:hover, &:focus, &:active': {
      backgroundColor: '#e5f5ff !important',
      color: '#2845d2 !important',
    },
  },
});

export default styles;
